var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['component.login'] = (function () {
    'use strict';

    const desktopBreakpoint = window.matchMedia('(min-width: 992px)');
    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const initialize = (modal) => {
        const triggers = document.querySelectorAll('[data-login-trigger]');
        let modalInstance = null;
        let desktopMode = false;

        if (!triggers.length) return;

        const setTriggerState = (expanded) => {
            triggers.forEach(trigger => trigger.setAttribute('aria-expanded', expanded.toString()));
        };

        const getVisibleTrigger = () => {
            return [...triggers].find(trigger => trigger.getClientRects().length > 0);
        };

        const getVisibleModalElements = () => {
            return [...modal.querySelectorAll(focusableSelector)]
                .filter(element => element.getClientRects().length > 0);
        };

        const alignDesktopDialog = () => {
            if (!desktopMode) return;

            const visibleTrigger = getVisibleTrigger();
            if (!visibleTrigger) return;

            const header = document.querySelector('.site-header');
            const triggerBounds = visibleTrigger.getBoundingClientRect();
            const headerBottom = header?.getBoundingClientRect().bottom ?? triggerBounds.bottom;
            const rightOffset = document.documentElement.clientWidth - triggerBounds.right;
            modal.style.setProperty('--login-modal-top', `${headerBottom}px`);
            modal.style.setProperty('--login-dialog-top', `${triggerBounds.bottom + 6 - headerBottom}px`);
            modal.style.setProperty('--login-dialog-right', `${rightOffset}px`);
        };

        const trapDesktopFocus = (event) => {
            if (!desktopMode || event.key !== 'Tab') return;

            const visibleTrigger = getVisibleTrigger();
            const modalElements = getVisibleModalElements();
            const firstModalElement = modalElements[0];
            const lastModalElement = modalElements[modalElements.length - 1];

            if (!visibleTrigger || !firstModalElement || !lastModalElement) return;

            if (event.shiftKey && document.activeElement === visibleTrigger) {
                event.preventDefault();
                lastModalElement.focus();
            } else if (!event.shiftKey && document.activeElement === visibleTrigger) {
                event.preventDefault();
                firstModalElement.focus();
            } else if (event.shiftKey && document.activeElement === firstModalElement) {
                event.preventDefault();
                visibleTrigger.focus();
            } else if (!event.shiftKey && document.activeElement === lastModalElement) {
                event.preventDefault();
                visibleTrigger.focus();
            }
        };

        const closeOnOutsideClick = (event) => {
            if (!desktopMode || !modal.classList.contains('show')) return;
            if (event.target.closest('[data-login-trigger]') || event.target.closest('.modal-content')) return;

            (modalInstance || bootstrap.Modal.getInstance(modal))?.hide();
        };

        const show = (trigger) => {
            desktopMode = desktopBreakpoint.matches;
            modal.classList.toggle('login__modal--desktop', desktopMode);
            alignDesktopDialog();
            modalInstance = new bootstrap.Modal(modal, {
                backdrop: desktopMode ? false : true,
                focus: !desktopMode
            });
            modal._loginTrigger = trigger;
            modalInstance.show();
        };

        triggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                if (modal.classList.contains('show')) {
                    modalInstance.hide();
                    return;
                }

                show(trigger);
            });
        });

        modal.addEventListener('shown.bs.modal', () => {
            setTriggerState(true);
            if (desktopMode) modal.querySelector('#username')?.focus();
        });

        modal.addEventListener('hidden.bs.modal', () => {
            setTriggerState(false);
            modal.classList.remove('login__modal--desktop');
            (modalInstance || bootstrap.Modal.getInstance(modal))?.dispose();
            modalInstance = null;
            modal._loginTrigger?.focus();
        });

        document.addEventListener('keydown', trapDesktopFocus);
        document.addEventListener('click', closeOnOutsideClick);

        desktopBreakpoint.addEventListener('change', () => {
            if (modal.classList.contains('show')) modalInstance.hide();
        });

        window.addEventListener('resize', alignDesktopDialog);
    };

    return { initialize };
})();